/**
 * Mutation `meta`. A failed mutation shows an error toast by default (app/MutationErrorToasts.tsx), so an
 * action never fails silently. Opt out with `noErrorToast` when the caller already renders the error
 * (a form or dialog `InlineError`, `ConfirmDialog`, `ImageUpload`) or when the mutation runs in the background.
 */
export type AppMutationMeta = {
  /** false: the caller shows the error itself (or it is deliberately silent). Defaults to true. */
  errorToast?: boolean;
};

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: AppMutationMeta;
  }
}

export const noErrorToast: AppMutationMeta = { errorToast: false };
